export function attach(handleUnload, router, route, handleRouteUnload) {
  if (handleUnload && typeof handleUnload === "function") {
    window.onbeforeunload = handleUnload;
    if (router && route) {
      const handle =
        typeof handleRouteUnload === "function"
          ? handleRouteUnload
          : handleUnload;
      router.setRouteLeaveHook(route, handle);
    }
  }
}

export function detach() {
  window.onbeforeunload = function() {
    return null;
  };
}



// WEBPACK FOOTER //
// ./ecology9/wea-tools/onbeforeunload.js